import { useEffect } from 'react'
import { SheetHeader } from '../components/SheetHeader'
import { SheetMargin } from '../components/SheetMargin'
import { CompoundTitleSheet } from '../compound/CompoundTitleSheet'
import { CompoundCapabilities } from '../compound/CompoundCapabilities'
import { CompoundIndustry } from '../compound/CompoundIndustry'
import { CompoundMemory } from '../compound/CompoundMemory'
import { CompoundRegister } from '../compound/CompoundRegister'
import { CompoundTraverse } from '../compound/CompoundTraverse'
import { CompoundModels } from '../compound/CompoundModels'
import { CompoundCaution } from '../compound/CompoundCaution'
import { CompoundClosing } from '../compound/CompoundClosing'

/*
THESIS: Compound is a measured product sheet — adaptive engineering method that deepens on the buyer's terrain.
OWN-WORLD: Same survey grammar as the home sheet. Cool white, magenta overprint for actions and cautions only.
STORY: CTO/Head of Eng reads the adaptive headline, scans the capability register, believes compounding, chooses a plan.
FIRST VIEWPORT: Full-width title + stamp; capability register rules cut the fold. No chart field.
*/

export function Compound() {
  useEffect(() => {
    document.title =
      'Compound — The Delivery System That Learns Your Project | Passwork Software Solution'
    const meta = document.querySelector('meta[name="description"]')
    if (meta) {
      meta.setAttribute(
        'content',
        'Compound adapts to your codebase and improves with every run. Subscription includes living skills, priority support, staff training, and index onboarding. For Cursor. USD 2,000/month or USD 20,000/year.',
      )
    }
  }, [])

  return (
    <>
      <SheetHeader />
      <main>
        <CompoundTitleSheet />
        <CompoundCapabilities />
        <CompoundIndustry />
        <CompoundMemory />
        <CompoundRegister />
        <CompoundTraverse />
        <CompoundModels />
        <CompoundCaution />
        <CompoundClosing />
      </main>
      <SheetMargin variant="compound" />
    </>
  )
}
